import React, { useState, useRef } from "react";
import moment from "moment";
import constants from "../../config/constants";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import PlansForm from "../plans/PlansForm";
import { useHistory, useLocation } from "react-router";
import { isInGracePeriod } from "../../utils/helper";

const CurrentPlan = ({ freeUntil, myPlan, hasAccessUntil, gracePeriod, isMember }) => {
  const location = useLocation();
  const [showPlansModal, setShowPlansModal] = useState(false);
  const ref = useRef(null);
  let isFree = moment(freeUntil).isAfter(moment());

  const history = useHistory();

  useOnClickOutside(ref, () => setShowPlansModal(false));

  const query = new URLSearchParams(location.search);
  if (query.get("nonFree")) {
    isFree = false;
  }

  const now = moment();
  const endDate = moment(hasAccessUntil);
  const grace = moment(hasAccessUntil).subtract(gracePeriod, "days");
  const isInGracePeriod = endDate.isAfter(now) && grace.isBefore(now);
  const isPlanVisible = myPlan && myPlan.isPlanVisible || false
  const isPlanName = myPlan && myPlan.planName ? true : false || false
  const ValidUntil = () => {
    return (
      <div className="border-l border-gray-300">
          <div className="py-5 lg:px-16 px-5">
            <div className="lg:text-base lg:font-bold text-sm leading-4 pt-5">
              Valid Until
            </div>
            <div className="pt-2 lg:text-3xl text-xl">
              {moment(hasAccessUntil)
                .subtract(gracePeriod, "days")
                .format("ll")}
            </div>
          </div>
        </div>
    );
  }

  return (
    <div className="flex w-full lg:w-auto justify-center lg:justify-start">
      {(isFree || isMember) && (
        <ValidUntil />
      )}

      {!isFree && myPlan && !isMember && (
        <div className="flex">
          { isPlanName && (
          <div className="lg:border-l border-gray-300">
            <div className="py-5 lg:px-16 px-5">
              <div className="lg:text-base lg:font-bold text-sm leading-4 pt-5">
                {myPlan.planName}
              </div>
              <div className="py-2 lg:text-3xl text-xl">
                {myPlan.frequency === "YEAR" && "Annual"}
                {myPlan.frequency === "MONTH" && "Monthly"} US$
                {Number(myPlan.price)}
              </div>

              <div ref={ref} className="relative inline-block text-left">
                <div>
                  {isInGracePeriod ? (
                    <button
                      onClick={() => history.push("/")}
                      className="text-sm text-blue-brand-700 focus:outline-none"
                    >
                      Renew your subscription
                    </button>
                  ) : (
                    <button
                      onClick={() => setShowPlansModal(!showPlansModal)}
                      className="text-sm text-blue-brand-700 focus:outline-none"
                    >
                      Cancel your plan
                    </button>
                  )}
                </div>
                {showPlansModal && (
                  <div className="origin-top-right absolute right-0 mt-2 w-56 rounded shadow-lg">
                    <div
                      className="rounded-md bg-white shadow-xs"
                      style={{ minWidth: "400px" }}
                    >
                      <PlansForm myPlan={myPlan} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          )}

          {!(isPlanVisible && !isPlanName) && (
          <div className="border-l border-gray-300">
            <div className="py-5 lg:px-16 px-5">
              <div className="lg:text-base lg:font-bold text-sm leading-4 pt-5">
                Renewal Date
              </div>
              <div className="pt-2 lg:text-3xl text-xl">
                {moment(hasAccessUntil)
                  .subtract(gracePeriod, "days")
                  .format("ll")}
              </div>
            </div>
          </div>
         )}
        </div>
      )}

       {!isFree && !isMember && isPlanVisible && !isPlanName && (
        <div className="flex">
          <div className="lg:border-l border-gray-300">
            <div className="py-5 lg:px-16 px-5">
              <div className="lg:text-base lg:font-bold text-sm leading-4 pt-5">
                Your subscription has been cancelled
              </div>
              <div className="py-2 lg:text-3xl text-xl">CANCELLED</div>
              <div>
                {isInGracePeriod && (
                  <button
                    onClick={() => history.push("/")}
                    className="text-sm text-blue-brand-700 focus:outline-none"
                  >
                    Renew your subscription
                  </button>
                )}
              </div>
            </div>
          </div>
          <ValidUntil />
        </div>
      )}
    </div>
  );
};

export default CurrentPlan;
